import { Component, Input, OnChanges } from '@angular/core';
import { TaxaIdealService } from '../../../services/taxaIdeal/taxa-ideal.service';
import { LegendaTaxasIdeais } from 'app/interfaces/Taxa-ideal';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from 'app/components/loading/loading.component';
import { InfoPopupComponent } from 'app/components/compartilhados/info-popup/info-popup.component';
import { TranslocoModule } from '@jsverse/transloco';
import { MapaCamadasService, ConfiguracaoCamadasMapa } from 'app/services/mapa-camadas/mapa-camadas.service';
import { VelocidadeIdealService } from 'app/services/velocidadeIdeal/velocidade-ideal.service';
import { VelocidadeIdeal } from 'app/interfaces/Velocidade-ideal';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dialog-legenda-mapa',
  standalone: true,
  imports: [CommonModule, LoadingComponent, InfoPopupComponent, TranslocoModule],
  templateUrl: './dialog-legenda-mapa.component.html',
  styleUrls: ['./dialog-legenda-mapa.component.css']
})
export class DialogLegendaMapaComponent implements OnChanges {

  @Input() operacaoId!: number | null;
  @Input() tipo!: string | null;

  public legenda!: LegendaTaxasIdeais;
  public carregando = false;
  public tipoTaxa = false;

  public tiposTaxaLegendas: any = {
    muda_ton_ha: 'toneladas',
    muda_tol_m: 'toletes',
    liquido: 'litros',
    profundidade: 'metros',
    solido: 'quilos'
  };

  public readonly camadas$: Observable<ConfiguracaoCamadasMapa>;

  public readonly velocidadeIdeal$: Observable<VelocidadeIdeal>;

  constructor(
    private readonly taxaIdealService: TaxaIdealService,
    private readonly mapaCamadasService: MapaCamadasService,
    private readonly velocidadeIdealService: VelocidadeIdealService
  ) {
    this.camadas$ = this.mapaCamadasService.camadas$;
    this.velocidadeIdeal$ = this.velocidadeIdealService.velocidadeIdeal$;
  }

  ngOnChanges(): void {
    const tiposSemRequisicaoDeTaxas = ['rastros', 'falhas', 'velocidade'];

    if (this.tipo && !tiposSemRequisicaoDeTaxas.includes(this.tipo)) {
      this.tipoTaxa = true;

      if (this.operacaoId) {
        this.carregando = true;
        this.buscarLegendaMapa(this.operacaoId, this.tipo);
      }
    } else {
      this.tipoTaxa = false;
    }
  }

  public buscarLegendaMapa(operacaoId: number, tipo: string): void {
    this.taxaIdealService
      .buscarLegendaMapa(operacaoId, tipo)
      .subscribe((legenda: LegendaTaxasIdeais) => {
        this.legenda = legenda;
        this.carregando = false;
      });
  }
}